import React from 'react';
import BillFlowDetailContainer from '../../containers/billflow/BillFlowDetailContainer';

const BillFlowDetailPage = () => {
  return <BillFlowDetailContainer />;
};

export default BillFlowDetailPage;
